import React from "react";
import styles from "./Footer.module.css";
const Footer = () => {
  return (
    <footer>
      <p className={styles.footer}> Alguns direitos reservados.</p>
    </footer>
  );
};

export default Footer;
